import { Accordion } from 'semantic-ui-react';
export default Accordion;